import styled, { injectGlobal, Themed } from 'styled-components';

import colors from '../../../node_modules/pubweb-react-components/dist/styles/colors';

import LandingPageStyles from '../../styles/LandingPageStyles';

import desktopImage from '../../images/desktop/thank-you-bg.jpg';
import tabletImage from '../../images/tablet/tablet-thank-you-bg.jpg';
import mobileImage from '../../images/mobile/mobile-thank-you-bg.jpg';


const ThankYouStyleProps = {
    desktop: {
        messagePaddingLeft: 47,
        messagePaddingRight: 73,
        headerRuleOffset: 6,
        boxLeftOffsetPercentage: 4.86
    },
    tablet: {
        messagePaddingLeft: 36,
        messagePaddingRight: 44,
        headerRuleOffset: 6,
        boxLeftOffsetPercentage: 4.86
    },
    mobile: {
        messagePaddingLeft: 17,
        messagePaddingRight: 23,
        headerRuleOffset: 0,
        boxLeftOffsetPercentage: 4.86
    }
};

const ThankYouMessageContainer = styled.div`
    
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: ${colors.grayscaleCoolGray11};
    height: 100%;
    position: relative;
    width: 100%;

    .background-filter {
        background-color: ${LandingPageStyles.grayFilter};
        float: left;
        height: 100%;
        width: 100%;
    }

    .body-copy-component {
        font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
    }

    .thank-you-rule {
        border-top: 1px solid lightgray;
    }

    .primary-button {
        padding-bottom: 14px;
        padding-left: 45px;
        padding-right: 45px;
        padding-top: 17px;
    }
    
    .thank-you-message {
        background-color: #FFFFFF;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
        border-top: 16px solid ${colors.secondaryKiddiePool};
        box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.19);
        left: ${ThankYouStyleProps.desktop.boxLeftOffsetPercentage}%;
        position: absolute;
        top: 22.77%;

        @media screen and (max-height: 700px) {
            bottom: 10%;
            top: auto;
        }

        .body-copy-component {
            font-size: 20px;
        }
    }

    .thank-you-header {
        .heading-component {
            margin-bottom: -17px;
            padding-left: 4px;

            h1 {
                letter-spacing: -1px;
            }
        }

        .body-copy-component {
            font-weight: 0; 
            letter-spacing: -.45px;
            line-height: 1.5;
            margin-top: 21px;
            padding-left: 1px;
        }
    }

    .thank-you-footer {
        font-weight: 600;
        margin-top: 22px;
        padding-left: 4px;

        .body-component {
            letter-spacing: .8px;
        }
    }

    
    
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        background-image: url('${desktopImage}');

        .thank-you-message {
            height: 460px;
            padding-left: ${ThankYouStyleProps.desktop.messagePaddingLeft}px;
            padding-right: ${ThankYouStyleProps.desktop.messagePaddingRight}px;
            padding-top: 15px;
            width: 460px;
        }

        .primary-button {
            margin-left: -2px;
            margin-top: -10px;
        }

        .thank-you-rule {
            margin-top: 28px;
            margin-left: ${(ThankYouStyleProps.desktop.messagePaddingLeft * -1 + ThankYouStyleProps.desktop.headerRuleOffset)}px;
            width: calc(100% + ${ThankYouStyleProps.desktop.messagePaddingRight + ThankYouStyleProps.desktop.messagePaddingLeft - ThankYouStyleProps.desktop.headerRuleOffset * 2}px);
        }
    }

    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        background-image: url('${tabletImage}');

        .thank-you-message {
            height: 460px;
            max-width: ${100 - (ThankYouStyleProps.desktop.boxLeftOffsetPercentage * 2)}%;
            padding-left: ${ThankYouStyleProps.tablet.messagePaddingLeft}px;
            padding-right: ${ThankYouStyleProps.tablet.messagePaddingRight}px;
            padding-top: 15px;
            width: 414px;
        }

        .primary-button {
            margin-left: -2px;
            margin-top: -10px;
        }

        .thank-you-rule {
            margin-top: 48px;
            margin-left: ${(ThankYouStyleProps.tablet.messagePaddingLeft * -1 + ThankYouStyleProps.tablet.headerRuleOffset)}px;
            width: calc(100% + ${ThankYouStyleProps.tablet.messagePaddingRight + ThankYouStyleProps.tablet.messagePaddingLeft - ThankYouStyleProps.tablet.headerRuleOffset * 2}px);
        }
    }

    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
        background-image: url('${mobileImage}');

        .thank-you-message {
            height: 419px;
            left: auto;
            margin-left: auto;
            margin-right: auto;
            padding-left: ${ThankYouStyleProps.mobile.messagePaddingLeft}px;
            padding-right: ${ThankYouStyleProps.mobile.messagePaddingRight}px;
            padding-top: 0px;
            position: relative;
            top: 15.6%;
            width: calc(100% - 44px);

            .body-copy-component {
                font-size: 18px;
            }
        }

        .primary-button {
            margin-left: -2px;
            margin-top: -8px;
        }

        .thank-you-rule {
            margin-top: 10px;
            margin-left: ${(ThankYouStyleProps.mobile.messagePaddingLeft * -1 + ThankYouStyleProps.mobile.headerRuleOffset)}px;
            width: calc(100% + ${ThankYouStyleProps.mobile.messagePaddingRight + ThankYouStyleProps.mobile.messagePaddingLeft - ThankYouStyleProps.mobile.headerRuleOffset * 2}px);
        }
        
        
        .thank-you-footer {
            margin-top: 8px;

            .body-copy-component {
                margin-top: 0;
            }
        }
    }
`;

export default ThankYouMessageContainer;


// WEBPACK FOOTER //
// ./src/components/ThankYou/ThankYouMessageStyles.js